module.exports = __webpack_public_path__ + "static/media/linux.f98141e8.png";